// The gift recipient page carries a gift card code, which is cash, in its
// path. Every analytics destination ships the page URL with each event, so
// nothing on this path may reach one (D23).
export const GIFT_PAGE_PREFIX = '/gift/';

export const isGiftPagePath = (pathname: string | null | undefined): boolean =>
  !!pathname?.startsWith(GIFT_PAGE_PREFIX);

// Leaving the page is a new document, never an in-app navigation: the tags the
// next page loads watch the history, and Back would hand them this address.
export const leaveGiftPage = (path: string) => window.location.assign(path);

// The PostHog properties that carry this site's page address: the URL an event
// was captured on and captureError's own copies.
const PAGE_PROPERTIES = [
  '$current_url',
  '$pathname',
  'current_page',
  'current_route',
];

// The referrer counts only on this origin: another site's page whose path
// happens to hold /gift/ would otherwise silence a whole visit.
export const holdsGiftPagePath = (
  properties: Record<string, unknown> | undefined,
  origin: string
): boolean => {
  const referrer = properties?.$referrer;
  return (
    PAGE_PROPERTIES.some((key) => {
      const value = properties?.[key];
      return typeof value === 'string' && value.includes(GIFT_PAGE_PREFIX);
    }) ||
    (typeof referrer === 'string' &&
      referrer.startsWith(`${origin}${GIFT_PAGE_PREFIX}`))
  );
};
